/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import "./Banner.css";
import { HostEnvironments } from "../../config/env";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Text } from "../general/Text";
import { withIsVisible } from "../../utils/reactUtils";
import { TABLET_WIDTH, useIsMobile } from "hooks/useDeviceType";
import { useDeviceBasedTextStyles } from "hooks/useDeviceBasedTextStyles";
import { Z_INDICES } from "config/consts";
import closeIconImgSrc from "../../img/trade-history/close.svg";

export const Banner = withIsVisible(() => {
  const isMobile = useIsMobile();
  const BANNER_STYLES_BY_ENV: Record<string, string> = {
    [HostEnvironments.BETA]: "#E9BA04",
  };
  const textStyles = useDeviceBasedTextStyles({ shouldScale: false });
  const font = textStyles["Title"]["XS"];
  const [isShown, setIsShown] = useState(true);

  if (!isShown) return null;

  const bannerText = () => {
    if (isMobile) {
      return (
        <div
          css={css`
            text-align: center;
            font: ${font};
          `}
        >
          <Text as={"span"} textStyle={"Title"} size={"XS"} shouldScale={false}>
            You are currently trading on a beta version of Bebop. Try{" "}
          </Text>
          <a
            href="https://docs.bebop.xyz/beta/bebop-ui/whats-new"
            target="_blank"
            rel="nofollow noreferrer"
            css={css`
              font-weight: 600;
              text-decoration: underline;
              cursor: pointer;
            `}
          >
            what’s new
          </a>{" "}
          or click{" "}
          <a
            href="https://bebop.xyz/trade"
            css={css`
              display: inline-block;
              font-weight: 600;
              text-decoration: underline;
              cursor: pointer;
            `}
          >
            here
          </a>{" "}
          to go back.
        </div>
      );
    }
    return (
      <div
        css={css`
          text-align: center;
        `}
      >
        <Text
          textStyle={"Title"}
          size={"XS"}
          shouldScale={false}
          textCss={css`
            display: inline-block;
          `}
        >
          You are currently trading on a beta version of Bebop. Try&nbsp;
        </Text>
        <a
          href="https://docs.bebop.xyz/beta/bebop-ui/whats-new"
          target="_blank"
          rel="nofollow noreferrer"
        >
          <Text
            shouldScale={false}
            textStyle={"Title"}
            size={"XS"}
            textCss={css`
              display: inline-block;
              font-weight: 600;
              text-decoration: underline;
              cursor: pointer;
            `}
          >
            what’s new&nbsp;
          </Text>
        </a>
        <Text
          shouldScale={false}
          textStyle={"Title"}
          size={"XS"}
          textCss={css`
            display: inline-block;
          `}
        >
          or head back to the&nbsp;
        </Text>
        <a href="https://bebop.xyz/trade" rel="nofollow noreferrer" target="_blank">
          <Text
            shouldScale={false}
            textStyle={"Title"}
            size={"XS"}
            textCss={css`
              display: inline-block;
              font-weight: 600;
              text-decoration: underline;
              cursor: pointer;
            `}
          >
            public version.
          </Text>
        </a>
      </div>
    );
  };

  return (
    <BannerContainer style={{ background: BANNER_STYLES_BY_ENV[HostEnvironments.BETA] }}>
      <Content>{bannerText()}</Content>
      <CloseButton onClick={() => setIsShown(false)}>
        <img src={closeIconImgSrc} alt="Close icon" width={CLOSE_ICON_SIZE} />
      </CloseButton>
    </BannerContainer>
  );
});

// Sub-components
const BannerContainer = styled.div`
  min-height: 40px;
  font-size: 18px;
  color: #192e2e;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px;
  width: 100%;
  z-index: ${Z_INDICES.POP_UPS};
  position: relative;
`;

const CLOSE_ICON_SIZE = 20;
const Content = styled.div`
  flex-grow: 1;
  position: relative;
  left: ${CLOSE_ICON_SIZE}px;

  @media (max-width: ${TABLET_WIDTH}px) {
    left: unset;
  }
`;

const CloseButton = styled.button`
  position: relative;
  top: 4px;
`;
